import styled from 'styled-components';

export const DateTimePicker = styled.input`
  border-width: 1px;
  border-color: black;
  padding: 6px;
  font-family: sans-serif;
  font-size: 14px;
`;
